import React from "react";
import InfoPanel from "../components/RightPannel";
import OTPVerificationForm from "./LeftPanel";
const OTPVerification = () => {
  return (
    <InfoPanel parent="otp">
      <OTPVerificationForm />
    </InfoPanel>
  );
};

export default OTPVerification;
